import styled from "styled-components";

export const StylesPageTitleWrapper = styled.div`
    max-width: 1366px;
    margin: 0 auto;
    padding: 32px 43px 16px;
    @media (max-width: 768px) {
        padding: 0 10px;
    }
`;
